import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "chat-search-panel content-block" }
const _hoisted_2 = { class: "search-row flex align-items-center" }
const _hoisted_3 = { class: "search-input-container flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "chat-search-panel__chats-tabs"
}
const _hoisted_5 = { class: "chat-search-panel__chats-tabs-back" }
const _hoisted_6 = { class: "chat-search-panel__chats-tabs-items" }
const _hoisted_7 = ["onClick"]

import {
	computed,
	ref,
	watch
} from "vue";
import {
	useRoute,
	useRouter
} from "vue-router";
import {Chat, ChatHistoryItem, chatsStore} from "@/store/chats";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatSearchPanel',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue', 'request-focus'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit;

const store = chatsStore()
const router = useRouter()
const route = useRoute()

const searchText = ref("");

const chatsTabs = computed(() => store.getOpenedChatsHistory)
const openedChatId = computed(() => store.getOpenedChatId)
const openedChat = computed(() => store.getOpenedChat)

const getUnreadCount = (chatId: number): number =>
	store.dialogs.find(d => d.Id === chatId)?.UnreadCount ?? 0

const tabDisplayName = (tab: ChatHistoryItem): string => {
	const name = tab.Name
		|| (openedChatId.value === tab.Id ? openedChat.value?.Name : '')
		|| ''
	return name || '…'
}

const goBack = async () => {
	searchText.value = ""
	await router.push({
		path: '/',
		query: {
			page: 'chat',
			mode: 'list',
		}
	});
	store.setMode('list')
	store.setOpenedChat(null)
}
const onOpenDialog = async (chatId: number) => {
	if (store.getOpenedChatId !== chatId) {
		emit('request-focus')
	}
	searchText.value = "";
	await router.push({
		path: '/',
		query: {
			...route.query,
			mode: 'chat',
			id: chatId
		}
	});
	store.setOpenedChat(chatId)
	store.setMode('chat')
}


const onDeleteTab = async (chatId: number) => {
	if (openedChatId.value === chatId) {
		searchText.value = ""
		await router.push({
			path: '/',
			query: {
				page: 'chat',
				mode: 'list',
			}
		});
	}
	store.deleteOpenedChatsHistory(chatId)
	store.setMode('list')
	store.setOpenedChat(null)
}

const onCreateChat = async () => {
	await router.push({
		path: '/',
		query: {
			...route.query,
			mode: 'create-chat'
		}
	});
	store.setMode('create-chat')
	store.setOpenedChat(null)
}

const onEditChat = async () => {
	await router.push({
		path: '/',
		query: {
			...route.query,
			mode: 'edit-chat'
		}
	});
	store.setEditedChat(openedChat.value)
	store.setMode('edit-chat')
	store.setOpenedChat(null)
}

watch(searchText, (newVal) => {
	if (newVal !== props.modelValue) {
		emit('update:modelValue', searchText.value)
	}
})

watch(() => props.modelValue, (newVal) => {
	if (newVal !== searchText.value) {
		searchText.value = newVal;
	}
})

function clearSearch() {
	searchText.value = "";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppTooltip, {
        class: "chat-search-panel__add-btn",
        text: "Создать беседу"
      }, {
        activator: _withCtx(() => [
          _createVNode(AppIcon, {
            name: "plus",
            width: "20px",
            color: "#979797",
            "hover-color": "#499259",
            cursor: "pointer",
            onClick: onCreateChat
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppInput, {
          modelValue: searchText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
          class: "search-input",
          placeholder: "Поиск",
          "show-search-button": ""
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(AppTooltip, {
        class: "chat-search-panel__edit-btn",
        text: "Редактировать беседу"
      }, {
        activator: _withCtx(() => [
          (
							openedChat.value
							&& !openedChat.value.IsSystem
							&& openedChat.value.CanEdit
						)
            ? (_openBlock(), _createBlock(AppIcon, {
                key: 0,
                name: "settings-outline",
                width: "18px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer",
                onClick: onEditChat
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (chatsTabs.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(AppIcon, {
              class: "chat-search-panel__chats-tabs-back-btn",
              name: "arrow-return",
              width: "20px",
              color: "#979797",
              "hover-color": "#499259",
              cursor: "pointer",
              onClick: goBack
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatsTabs.value, (chat) => {
              return (_openBlock(), _createBlock(AppTooltip, {
                class: "chat-dialog__body-header-tooltip",
                text: "Перейти к беседе",
                key: chat.Id
              }, {
                activator: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass({
								'chat-search-panel__chats-tabs-item': true,
								'chat-search-panel__chats-tabs-item--active': openedChatId.value === chat.Id,
							}),
                    key: chat.Id,
                    onClick: ($event: any) => (onOpenDialog(chat.Id))
                  }, [
                    _createTextVNode(_toDisplayString(tabDisplayName(chat)) + _toDisplayString(getUnreadCount(chat.Id) > 0 ? ` (${getUnreadCount(chat.Id)})` : '') + " ", 1),
                    _createVNode(AppIcon, {
                      class: "chat-dialog__body-header-tooltip",
                      name: "close-bold",
                      width: "12px",
                      color: openedChatId.value === chat.Id ? '#FFFFFF' : '#D2D2D2',
                      "hover-color": "#BA4C4C",
                      cursor: "pointer",
                      onClick: _withModifiers(($event: any) => (onDeleteTab(chat.Id)), ["stop"])
                    }, null, 8, ["color", "onClick"])
                  ], 10, _hoisted_7))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})